export const small = "@media (max-width: 768px)";
